import jwt_decode from "jwt-decode";

/**
 * Obtiene y decodifica la información del usuario contenida en el token JWT firmado.
 */
export const getAuthUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  try {
    return jwt_decode(token) || {};
  } catch (error) {
    console.error("Error al decodificar token JWT:", error);
    return {};
  }
};

/**
 * Obtiene un parámetro de autenticación desde el token JWT decodificado.
 * Si no está disponible en el token, se utiliza fallback al localStorage.
 *
 * @param {string} key Nombre de la clave requerida
 * @returns {string|null}
 */
export const getAuthParam = (key) => {
  const user = getAuthUser();

  switch (key) {
    case "id_perfil":
      if (user.id_perfil !== undefined && user.id_perfil !== null) {
        return String(user.id_perfil);
      }
      return localStorage.getItem("id_perfil");
    case "user_id":
      if (user.id_usuario !== undefined && user.id_usuario !== null) {
        return String(user.id_usuario);
      }
      return localStorage.getItem("user_id");
    case "id_usuario_sap":
      if (user.id_usuario_sap !== undefined && user.id_usuario_sap !== null) {
        return String(user.id_usuario_sap);
      }
      return localStorage.getItem("id_usuario_sap");
    case "usuarioNombre":
      return user.nombre ?? localStorage.getItem("usuarioNombre");
    case "perfil":
      return user.nombre_perfil ?? localStorage.getItem("perfil");
    case "foto_perfil":
      return user.photo ?? localStorage.getItem("foto_perfil");
    case "cod_division":
      return user.cod_division !== undefined ? user.cod_division : localStorage.getItem("cod_division");
    case "url_intranet":
      return user.url_intranet ?? localStorage.getItem("url_intranet");
    default:
      if (user[key] !== undefined && user[key] !== null) {
        return String(user[key]);
      }
      return localStorage.getItem(key);
  }
};
